//import Fetching from '@/services/FetchData';
import router from '@/router';

let getApi = () => import('@/services/Api');

const getStorageJson =
    (name) => sessionStorage.getItem(name) ? JSON.parse(sessionStorage.getItem(name)) : null
const putIntoStorage = (param, val) => {
    sessionStorage.removeItem(param);
    sessionStorage.setItem(param, val)
}
const putIntoStorageObject = (param, val) => {
    sessionStorage.removeItem(param);
    sessionStorage.setItem(param, JSON.stringify(val))
}

const state = {
    token: sessionStorage.getItem('token'),
    refreshToken: sessionStorage.getItem('refreshToken'),
    accessTokenExpiry: sessionStorage.getItem('accessTokenExpiry'),
    permissions: getStorageJson('permissions') || [],
    prevPath: '/',
    distributionPoint: getStorageJson('userDistributionPoint') || {},
    userInfo: getStorageJson('userInfo') || {},
    chosenLang: sessionStorage.getItem('chosenLang') || 'ENG',
    isDark: (sessionStorage.getItem('isDark') === 'true'),
};

const getters = {
    //единое место для проверки налияия доступа у пользователя к элементу
    isPerimitted: (state) => (object, method, type) => {
        let res = false;
        if (!object) {
            return !!state.token;
        }
        if (state.permissions && state.permissions.length > 0) {

            for (let item of state.permissions) {
                if (object) {
                    if (item.object.toLowerCase() === object.toLowerCase() &&
                        item.method.toLowerCase() === (method || item.method).toLowerCase() &&
                        item.type.toLowerCase() === (type || item.type).toLowerCase()) {
                        res = !!state.token;
                        break;
                    }

                }
            }
        }
        return res;
    },
    getChosenLang(state) {
        return state.chosenLang
    },
    getPrevPath: (state) => {
        return state.prevPath;
    },
    getDistributionPoint: (state) => state.distributionPoint,
    getDistributionPointName: (state, getters) => {
        const name = (state.distributionPoint && state.distributionPoint.name) ? state.distributionPoint.name : [];
        return name[getters.getChosenLang.toLowerCase()];
    },
    getUsername: (state) => {
        return state.userInfo ? (state.userInfo.fname || '') + ' ' + (state.userInfo.lname || '') : ''
    },
    getUserRoles: (state) => {
        return state.userInfo && state.userInfo.roles ? state.userInfo.roles.map(role => role.role).join(", ") : '';
    },
    getUserAutograph: (state) => {
        return state.userInfo ? (state.userInfo.fname && state.userInfo.fname.charAt(0) || '') + (state.userInfo.lname && state.userInfo.lname.charAt(0) || '') : ''
    },
    isUserVisor: (state) => {
        return (state.userInfo)?state.userInfo.isVisor:false
    },
    getIsDark: (state) => state.isDark,
    getRefreshToken: (state) => state.refreshToken,
    getExpiry: (state) => state.accessTokenExpiry,
};

const actions = {
    async storeIsDark({commit, getters}, payload) {
        if (getters.isPerimitted()) {
            let {http} = await getApi();
            http.postData(`/user/options`, {dark: payload.val});
        }
        commit('setIsDark', payload.val)
    },
    storePrevPath({commit}, payload) {
        const path = payload.prevPath;
        commit('setPrevPath', path);
    },
    async storeChosenLang({commit,getters}, payload) {
        if (getters.isPerimitted()) {
            let {http} = await getApi();
            http.postData(`/user/options`, {lang: payload.lang});
        }
        commit('setChosenLang', payload.lang);
    },
    storeUserDistributionPoint({commit}, payload) {
        commit('setUserDistributionPoint', payload);
    },
    storeUserInfo({commit}, payload) {
        commit('setUserInfo', payload);
    },
    async login({commit, getters, dispatch}, payload) {
        dispatch('storeProgress', {text: 'Please wait'}, {root: true});
        try {
            let {http} = await getApi();
            const response = await http.postData(`/login`, {username: payload.login, password: payload.password});
            if (response && response.data) {
                let {accessToken, refreshToken, expiry, userInfo = {}, permissions = []} = response.data;
                if (!accessToken || !refreshToken || !expiry)
                    return commit('setError', new Error('No credentials provided, please contact administrator'))
                commit('saveAccessCredentials', response.data);

                //сохраним информацию пользователя в хранилище приложения и сессии
                commit('setUserInfo', userInfo);
                commit('saveUserOptions', userInfo.options);
                commit('setUserDistributionPoint', userInfo.distributionPoint);

                //получим список доступов для пользователя по объектам БД
                const methodToAction = {GET: 'view', PUT: 'edit', POST: 'add', DELETE: 'delete', VIEW: 'gui'}
                if (permissions.length > 0 && permissions[0].id) {
                    let processedPermissions = permissions.map(item => ({
                            method: methodToAction[item.method],
                            object: item.code,
                            type: item.resourceType
                        })
                    )
                    commit('setPermissions', processedPermissions);
                } else {
                    router.push({path: '/'})
                    return;

                }
                //запросим справочники только после того как определимся с привилегиями
                dispatch('storeCatalogs', null, {root: true});
                dispatch('storeLangs', null, {root: true});
                dispatch('storeTranslations', null, {root: true});
                //Определим предыдущую страницу посещения что бы перекинуть пользователя на нее,
                //если мы зашли после сброса сесси по времени
                let prevPath = getters.getPrevPath
                prevPath = (prevPath === '/login') ? '/' : prevPath;
                router.push({
                    path: (prevPath) ? prevPath : '/'
                })
            } else if (response && response.data && !response.data.token) {
                commit('setError', new Error(response.data.toString()))
            } else if (response && !response.data) {
                commit('setError', new Error(response.toString()))
            }
        } catch (err) {
            commit('setError', err)
        } finally{
            dispatch('storeProgress', {text: null}, {root: true});
        }
    },
    storeUserCredentials({commit}, payload) {
        commit('saveAccessCredentials', payload);
    },
    async logOut({commit}) {
        //вызовим сервис что бы разлогиниться на сервере
        let {http} = await getApi();
        http.postData('/logout');
        //отчистим переменные хранилища что бы мог зайти другой пользователь
        commit('setPermissions', null);
        commit('setUserInfo', null);
        commit('setUserDistributionPoint', null);
        commit('saveAccessCredentials');
        sessionStorage.clear();
        commit('saveUserOptions',{});
        //перебросим на страницу аутентификации
        router.push({name: 'login'});

    }
};

// mutations
const mutations = {
    setIsDark(state, val) {
        state.isDark = val;
        putIntoStorage('isDark', val);
    },
    setPrevPath(state, item) {
        state.prevPath = item;
    },
    setPermissions(state, item) {
        state.permissions = item;
        putIntoStorageObject('permissions', item)
    },
    setUserInfo(state, item) {
        state.userInfo = item;
        putIntoStorageObject('userInfo', item)
    },
    setUserDistributionPoint(state, item) {
        state.distributionPoint = item;
        putIntoStorageObject('userDistributionPoint', item)
    },
    setChosenLang(state, lang) {
        state.chosenLang = lang;
        putIntoStorage('chosenLang', lang);
    },
    saveAccessCredentials(state, data) {
        let {accessToken, refreshToken, expiry} = data || {};
        state.token = accessToken;
        state.refreshToken = refreshToken;
        state.accessTokenExpiry = expiry;
        putIntoStorage('token', accessToken);
        putIntoStorage('refreshToken', refreshToken);
        putIntoStorage('accessTokenExpiry', expiry);
    },
    saveUserOptions(state, data) {
        let {lang = 'ENG', dark = false} = data || {};
        state.chosenLang = lang;
        state.isDark = dark;
        putIntoStorage('chosenLang', lang);
        putIntoStorage('isDark', dark);
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}